export default "__VITE_ASSET__BmxU3bHH__"